import { useState } from 'react';
import axios from 'axios';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      console.log('=== CONTACT FORM DEBUG ===');
      console.log('Form Data:', formData);
      console.log('API URL from env:', process.env.REACT_APP_API_URL);
      
      const apiUrl = 'http://localhost:5000/api/contact/send-message';
      console.log('Full URL:', apiUrl);
      
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Success Response:', response.data);
      
      if (response.data.success) {
        setStatus({ type: 'success', message: response.data.message });
        setFormData({ fullName: '', email: '', phone: '', subject: '', message: '' });
      }
    } catch (error) {
      console.error('=== ERROR DEBUG ===');
      console.error('Error object:', error);
      console.error('Error response:', error.response);
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      console.error('Error message:', error.message);
      
      setStatus({ 
        type: 'error', 
        message: error.response?.data?.message || error.message || 'Failed to send message. Please try again.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="relative w-full overflow-hidden rounded-[26px] p-5 sm:p-6 lg:p-7"
      style={{
        background: "rgba(255, 255, 255, 0.55)",
        backdropFilter: "blur(28px)",
        WebkitBackdropFilter: "blur(28px)",
        border: "1px solid rgba(255, 255, 255, 0.55)",
        boxShadow: "0 12px 40px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.7)",
      }}
    >
      <div className="relative">
        {/* Header */}
        <div className="mb-6">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-black/50">
            Get In Touch
          </span>

          <h2 className="mt-1.5 text-xl font-bold tracking-tight text-black sm:text-2xl leading-tight">
            Send us a Message
          </h2>

          <div className="mt-3 h-[2px] w-12 rounded-full bg-black/20" />
        </div>

        {/* Status Message */}
        {status.message && (
          <div className={`mb-4 p-3 rounded-xl text-sm font-medium ${
            status.type === 'success' 
              ? 'bg-green-50 text-green-700 border border-green-200' 
              : 'bg-red-50 text-red-700 border border-red-200'
          }`}>
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 sm:grid-cols-2">
            {/* Full Name */}
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-black/70">
                Full Name
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                className="h-11 w-full rounded-xl border border-black/10 bg-white/50 px-3.5 text-sm font-medium text-black outline-none placeholder:text-black/40 transition-all duration-300 focus:border-black/25 focus:bg-white/70 focus:ring-1 focus:ring-black/10"
              />
            </div>

            {/* Email */}
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-black/70">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                className="h-11 w-full rounded-xl border border-black/10 bg-white/50 px-3.5 text-sm font-medium text-black outline-none placeholder:text-black/40 transition-all duration-300 focus:border-black/25 focus:bg-white/70 focus:ring-1 focus:ring-black/10"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-black/70">
                Phone Number
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your number"
                required
                className="h-11 w-full rounded-xl border border-black/10 bg-white/50 px-3.5 text-sm font-medium text-black outline-none placeholder:text-black/40 transition-all duration-300 focus:border-black/25 focus:bg-white/70 focus:ring-1 focus:ring-black/10"
              />
            </div>

            {/* Subject */}
            <div>
              <label className="mb-1.5 block text-xs font-semibold text-black/70">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter subject"
                required
                className="h-11 w-full rounded-xl border border-black/10 bg-white/50 px-3.5 text-sm font-medium text-black outline-none placeholder:text-black/40 transition-all duration-300 focus:border-black/25 focus:bg-white/70 focus:ring-1 focus:ring-black/10"
              />
            </div>

            {/* Message */}
            <div className="sm:col-span-2">
              <label className="mb-1.5 block text-xs font-semibold text-black/70">
                Your Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message here..."
                required
                rows={3}
                className="h-[95px] w-full resize-none rounded-xl border border-black/10 bg-white/50 px-3.5 py-3 text-sm font-medium text-black outline-none placeholder:text-black/40 transition-all duration-300 focus:border-black/25 focus:bg-white/70 focus:ring-1 focus:ring-black/10"
              />
            </div>
          </div>

          {/* Bottom Row */}
          <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <button
              type="submit"
              disabled={loading}
              className="group inline-flex h-11 min-w-[160px] items-center justify-center gap-2 rounded-xl bg-black px-6 text-sm font-semibold text-white transition-all duration-300 hover:bg-black/85 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span>{loading ? 'Sending...' : 'Send Message'}</span>
              {!loading && <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>}
            </button>

            <div className="flex items-center gap-2 text-[11px] leading-4 text-black/55">
              <span className="text-base">🛡</span>
              <span>
                We respect your privacy.
                <br />
                Your information is safe with us.
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}